import get from 'lodash.get';
import React from 'react';

import ProfileCard from '../AboutUs/ProfileCard';
import PageSection from '../Common/PageSection';
import RichTextConverter from '../Common/RichText/RichTextConverter';
import ThreeUp from '../Common/ThreeUp';
import IconList from '../Generic/IconList';
import Accordion from './Accordion';
import * as styles from './GroupedContent.module.css';
import LargeCards from './LargeCards';
import TestimonialSection from './TestimonialSection';
import TicketThreeUpSection from './TicketThreeUpSection';
import WhyAttend from './WhyAttend';

const backgrounds = { 'Light Blue': styles.lightBlue, White: styles.white, Grey: styles.grey };
const GroupedContent = ({ section, i, fullImage = false, wide = false, noPad = false }) => {
  if (section.type === 'Three Up') {
    return (
      <ThreeUp
        wide={wide}
        id={'watchwords'}
        section={section}
        key={i}
        className={backgrounds[section.backgroundColor] || styles.white}
      />
    );
  } else if (section.type === 'Spark Three Up') {
    return <TicketThreeUpSection pageMeta={section} key={i} />;
  } else if (section.type === 'Accordion') {
    return (
      <PageSection slim key={i}>
        <h2>{section.heading}</h2>
        <RichTextConverter copy={section.sectionCopy} />
        <Accordion items={section.content} defaultCollapsed={false} className={styles.accordion} />
      </PageSection>
    );
  } else if (section.type === 'Icon List') {
    return (
      <PageSection slim key={i}>
        <IconList
          id={'operating-principals'}
          list={get(section, 'content', [])}
          gatsbyImage={section.mainImage?.gatsbyImageData}
          heading={section.title}
          paragraph={get(section, 'sectionCopy')}
        />
      </PageSection>
    );
  } else if (section.type === 'Large Cards' || section.type === 'Large Cards - Full Image') {
    return (
      <LargeCards
        wide={wide}
        fullImage={fullImage || section.type === 'Large Cards - Full Image'}
        section={section}
        noPad={section.backgroundColor === 'White' || noPad}
        className={backgrounds[section.backgroundColor] || styles.white}
      />
    );
  } else if (section.type === 'Testimonials') {
    return (
      <TestimonialSection
        testimonials={section.content}
        itemsPerRow={section.itemsPerRow}
        backgroundColor={section.backgroundColor}
      />
    );
  } else if (section.type === 'High-level Info') {
    return <WhyAttend section={section} />;
  } else if (section.type === 'Profile Cards') {
    let isSpark = false;
    if (typeof window !== 'undefined') {
      isSpark = window.location.pathname.indexOf(/spark/) > -1;
    }

    return (
      <PageSection slim key={i} className={backgrounds[section.backgroundColor] || styles.grey}>
        <div className={styles.profiles}>
          {isSpark && <h2>{section.heading}</h2>}
          <RichTextConverter copy={section.sectionCopy} />
          <div className={styles.profileGrid}>
            {section.content?.map((card, i) => {
              return (
                <ProfileCard
                  isSpark={isSpark}
                  accentColor={section.accentColor}
                  name={card.title}
                  image={card.image}
                  copy={card.body}
                  link={card.linkUrl}
                  key={i}
                />
              );
            })}
          </div>
        </div>
      </PageSection>
    );
  } else {
    return null;
  }

  /*else if (section.type === 'Template Standard') {
    return (
      <PageSection slim key={i} className={styles.grey}>
        <div className={styles.leadership}>
          <RichTextConverter copy={section.sectionCopy} />
          <div className={styles.leadershipGrid}>
            {section.content?.map((card, i) => {
              return <ProfileCard name={card.title} image={card.image} copy={card.body} link={card.linkUrl} key={i} />;
            })}
          </div>
        </div>
      </PageSection>
    );
  }*/
};

GroupedContent.propTypes = {
  // myProp: PropTypes.string.isRequired
};

export default GroupedContent;
